import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { UserContext } from './models/user-context.model';
import { MemberDetails } from './models/member-details.model';

export interface MemberState extends EntityState<MemberDetails> {
  user?: UserContext;
  availableAccounts?: MemberDetails[];
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'member', cache: { ttl: 30000 } })
export class MemberStore extends EntityStore<MemberState, MemberDetails> {
  constructor() {
    super({});
  }
}
